<app-add-name [parentComp]="'urgent'" (save)="onSave($event)" (cancelEvent)="onCancel()"></app-add-name>